import React from 'react';
import { DatePicker as RsuiteDatePicker } from 'rsuite';
import './index.css';

const DatePicker = ({ 
  label, 
  placeholder = "DD/MM/YYYY", 
  value, 
  onChange, 
  disabled = false,
  cleanable = false,
  size = "lg",
  format = "dd/MM/yyyy",
  oneTap = true,
  ...props 
}) => {
  // Convert string value to Date object if needed
  const dateValue = value ? (typeof value === 'string' ? new Date(value) : value) : null;

  const handleChange = (date) => {
    if (onChange) {
      onChange(date);
    }
  };

  return (
    <div className="custom-date-picker-wrapper">
      {label && <label className="custom-date-picker-label">{label}</label>}
      <RsuiteDatePicker
        className="custom-date-picker"
        placeholder={placeholder}
        value={dateValue}
        onChange={handleChange}
        disabled={disabled}
        cleanable={cleanable}
        size={size}
        format={format}
        oneTap={oneTap}
        style={{ width: '100%' }}
        {...props}
      />
    </div>
  );
};

export default DatePicker;
